import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { DependencyFilterKeys } from '../../../../../../shared/dependenciesV2';
import useFetchDependenciesAction from '../../hooks/useFetchDependencyAction';
import * as DependenciesV2Store from '../../../../../redux/dependenciesV2';
import type { SelectOption } from '../../../../../types';
import FilterCardMultiSelect from '../../../../generic/Filter/FilterCardMultiSelect';
import useRootProjects from '../../hooks/useRootProjects';

/**
 * Package manager filter which allows the user to filter dependencies by direct or transitive.
 * Uses the DepsV2 package-managers endpoint to obtain a list of available package managers.
 */
const RootProjectsFilter: VoidFunctionComponent = () => {
  const filters = useSelector(DependenciesV2Store.selectors.getFilters);
  const setFilter = useFetchDependenciesAction(DependenciesV2Store.actions.setFilters);

  const { areRootProjectsLoading, rootProjects } = useRootProjects();
  const isDisabled = areRootProjectsLoading || rootProjects.length <= 1;
  const hasSingleRootProject = rootProjects.length === 1;

  const selectedRootProjects = rootProjects.filter(
    (rootProject) => filters?.rootProjects?.includes(rootProject.value),
  );
  const onChange = (selected: SelectOption[]) => setFilter({
    ...filters,
    [DependencyFilterKeys.RootProjects]: selected.map((option) => option.value),
  });

  return (
    <FilterCardMultiSelect
      label="Projects"
      placeholder={areRootProjectsLoading ? 'Loading...' : 'Select one or more...'}
      options={rootProjects}
      values={hasSingleRootProject ? rootProjects : selectedRootProjects}
      onChange={onChange}
      isDisabled={isDisabled}
    />
  );
};

export default RootProjectsFilter;
